import { render, staticRenderFns } from "./version_msg.vue?vue&type=template&id=02975d1a&"
import script from "./version_msg.vue?vue&type=script&lang=js&"
export * from "./version_msg.vue?vue&type=script&lang=js&"
import style0 from "./version_msg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports